import React from 'react';

import { Paper } from '@material-ui/core';
import ScoreBar from 'components/ScoreBar';
import styled from 'styled-components';
import { fillMixin, mediumSizeMixin } from 'styles/common';

import { getDevelopmentLevelColor } from 'constants/helper';

// TODO: use strength level color
export default function ScoreDetail({
  strengthName,
  score,
  benchmarkValue,
  status = 'Intermediate',
  level,
  scoreBarWidth,
  scoreBarHeight,
}) {
  const color = getDevelopmentLevelColor(level);
  return (
    <StyledPaper>
      {/* <IconStatContainer> */}
      {/* {getStrengthIcon(strengthName, { size: 'small', color })} */}
      {/* <DevelopIcon color={color} size="small" /> */}
      {
        // commenting score as discussed with Saurabh.
        // This will be added back once the logic of number is more clear and we are able to give explain it to client
        /* <StyledTypography variant="h6" topGutter={true} weight={600} color={color}>
          {score}%
        </StyledTypography> */
      }
      {/* </IconStatContainer> */}
      <ScoreBarContainer>
        {/* <Typography variant="body1">Current Progress: {status}</Typography> */}
        <ScoreBar
          score={score}
          showBenchmark={false}
          benchmarkValue={benchmarkValue}
          color={color}
          showBenchmarkText={false}
          width={scoreBarWidth}
          height={scoreBarHeight}
        />
      </ScoreBarContainer>
      {/* <Typography14
        weight="600"
        color={color}
        leftGutter={3}
        style={{ lineHeight: 1 }}
      >{`${score}%`}</Typography14> */}
      {/* <BadgesContainer> */}
      {/* <StyledTypography>Mentor: </StyledTypography>
        <StyledAvatar
          src="https://d933oy9uoq0en.cloudfront.net/datamonk/Gaurav_Chaubey.jpeg"
          size="smaller"
        /> */}
      {/* <MediumIcon src={maleIconSrc} />
        <MediumIcon src={maleIconSrc} /> */}
      {/* </BadgesContainer> */}
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  padding: ${(props) => props.theme.spacing(2)}rem;
  // margin: ${(props) => props.theme.spacing(2)}rem 0;
  width: 100%;
  // margin-right: 1rem;
  align-items: center;
`;

const IconStatContainer = styled.div`
  flex: 1 1 auto;
  display: flex;
  text-align: center;
  margin-top: 0.875rem;
  align-items: center;
  padding: ${(props) => props.theme.spacing(1)}rem;
`;

const ScoreBarContainer = styled.div`
  flex: 1 3 84%;
  // padding: ${(props) => props.theme.spacing(1)}rem;
`;

const BadgesContainer = styled.div`
  flex: 1 1 8%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: ${(props) => props.theme.spacing(1)}rem;
`;

const MediumIcon = styled.img`
  ${fillMixin};
  ${mediumSizeMixin};
`;

// TODO: Change default to 0
ScoreDetail.defaultProps = {
  score: 60,
  benchmarkValue: 70,
};
